const frFR = {
  'common.appTitle': 'Performance Coach',
  'common.formHasErrors': 'Veuillez vérifier le formulaire pour les champs obligatoires',
  'common.from': 'De',
  'common.to': 'A',
  'common.today': "Aujourd'hui",
  'common.more': 'Plus',
  'common.editEntity': 'Modifier',
  'common.abort': 'Annuler',
  'common.delete': 'Supprimer',
  'common.language': 'Sélectionner la langue',
  'common.defaultMenuTitle': 'Rendez-vous',
  'common.signOut': 'Déconnexion',
  'common.defaultStoreSettings': 'Paramètres magasin',
  'common.save': 'Enregistrer',
  'common.confirm': 'Confirmer',
  'common.error': 'Erreur',
  'common.defaultError': "Une erreur s'est produite",
  'common.defaultErrorDescription': 'Videz le cache et rafraîchissez',
  'common.createAppointmentError': "Une erreur s'est produite lors de la création du rendez-vous",
  'common.createAppointmentErrorDescription': "Le rendez-vous n'a pas été créé. Veuillez vérifier votre connexion Internet",
  'common.deleteAppointmentError': "Une erreur s'est produite lors de la tentative de suppression du rendez-vous",
  'common.deleteAppointmentErrorDescription': "Le rendez-vous n'a pas été supprimé. Veuillez vérifier votre connexion Internet",
  'common.appVersion': 'Version',
  'common.minutesShort': '{minutes} min',
  'common.gender.none': '-',
  'common.gender.male': 'Monsieur',
  'common.gender.female': 'Madame',
  'common.search': 'Rechercher',
  'common.pageNotFound': 'Page non trouvée',
  'common.yes': 'Oui',
  'common.no': 'Non',
  'common.clearFilters': 'Effacer les filtres',
  'menu.operations': 'Opérations',
  'menu.performance': 'Performance',
  'menu.appointments': 'Rendez-vous',
  'menu.settings': 'Paramètres',
  'performanceIndicatorsColumnName.region': 'Région',
  'performanceIndicatorsColumnName.storeid': 'Identifiant du magasin',
  'performanceIndicatorsColumnName.ltb_status': 'Utilisation de LTB',
  'performanceIndicatorsColumnName.store_name': 'Nom du magasin',
  'performanceIndicatorsColumnName.last_week': 'Semaine dernière',
  'performanceIndicatorsColumnName.last_week_prev_year': 'Semaine dernière année précédente',
  'performanceIndicatorsColumnName.problems_count': 'Nombre de problèmes',
  'performanceIndicatorsColumnName.capacity_flag': 'Capacité',
  'performanceIndicatorsColumnName.capacity_flag_1': "La capacité de l'essai de vue est manquante",
  'performanceIndicatorsColumnName.potential_flag': 'Potentiel',
  'performanceIndicatorsColumnName.potential_flag_1': 'Faible utilisation du potentiel de test de vue (Travail en cours)',
  'performanceIndicatorsColumnName.wait_time_flag': 'Temps d attente',
  'performanceIndicatorsColumnName.wait_time_flag_1': 'Temps d attente élevé',
  'performanceIndicatorsColumnName.productivity_flag': 'Productivité',
  'performanceIndicatorsColumnName.productivity_flag_1': 'Faible productivité (Travail en cours)',
  'performanceIndicatorsColumnName.service_time_flag': 'Temps de service',
  'performanceIndicatorsColumnName.service_time_flag_1': 'Ils ont besoin de plus de 40 minutes pour effectuer un test de vue et une consultation',
  'performanceIndicatorsColumnName.status_50_pct_rule': 'Règle des 50 %',
  'performanceIndicatorsColumnName.conversion_rate_flag': 'Taux de conversion',
};

export default frFR;
